/**
 * Environment variables
 */
export const Env = {
  MODE: process.env.REACT_APP_ENV || "development",
  APP_NAME: process.env.REACT_APP_NAME || "databis",
  BASE_URL: process.env.REACT_APP_BASE_URL,
  ENVIRONMENT_ID: process.env.REACT_APP_DYNAMIC_ENVIRONMENT_ID || "",
  IMAGE: process.env.REACT_APP_MEDIA_UPLOAD_URL || "",
  MAXIMUM_DATE_ALLOWED: "2050-12-31",
  MIN_DATE_ALLOWED_HARVEST_DATE: "1990-01-01",
  PAYMENT_KEY: process.env.REACT_APP_PAYMENT_PUBLIC_KEY,
  ALCHEMY_API_KEY: process.env.REACT_APP_ALCHEMY_API_KEY,
  ALCHEMY_POLICY_ID: process.env.REACT_APP_ALCHEMY_POLICY_ID || "",
  ALCHEMY_RPC_URL: process.env.REACT_APP_ALCHEMY_RPC_URL || "",
  ALCHEMY_RPC_URL_WITH_KEY:
    `${process.env.REACT_APP_ALCHEMY_RPC_URL}${process.env.REACT_APP_ALCHEMY_API_KEY}` ||
    "",
  ACCOUNT_PUBLIC_KEY: `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAt4lyG7rz9QrBzMK0P9dG
RR8GsPWseWiB9bx5obC7bzzxxFPdNNyNu28sl6eUdCglmGulLXjoUXwwO59e9cvR
+dRiBarIVA8fE2i8sorPJGvECX09JSlx5gveYZru1Q1b8Mw3x3ZKvKhdVgJO8Cf8
xLhgFTHb+ovLothmL+vwmNbLTGlkLKOYMyLjpsJAZ6okhAzRx0301s7k9HdxkHyl
e+gQEEbLDt0VlPTeu14wC1FsIphqRuE8PEcJCcmgzGcEXImA9A+xyjDiENVJdy23
0vn0YjryXTG2LbI1bJBn+IQflNXAbuaU/YmOPLIlLUgl9qDQJcwlxLZnRJFVGXgi
SwIDAQAB
-----END PUBLIC KEY-----`,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL || "",
  BRAND_SUPPORT_URL: process.env.REACT_APP_BRAND_SUPPORT_URL || "",
  BRANDS_NORDIC_INTEGRATION_SETUP_TUTORIAL:
    process.env.REACT_APP_BRANDS_NORDIC_INTEGRATION_SETUP_TUTORIAL ||
    "https://support.brands.databis.io/hc/en-us/articles/44188073676307-Nordic-Analytic-Integration-Setup",

  IPFS_GATEWAY_URL: process.env.REACT_APP_IPFS_GATEWAY_URL || "",
  AEROPAY_CONSUMER_ID: process.env.REACT_APP_AEROPAY_CONSUMER_ID || "",
  SUPPORT_EMAIL:
    process.env.REACT_APP_SUPPORT_EMAIL || "support@brands.databis.io",
  MIN_DESKTOP_VIEWPORT_WIDTH: 1024,
  POSTHOG_KEY: process.env.REACT_APP_PUBLIC_POSTHOG_KEY || "",
  POSTHOG_HOST: process.env.REACT_APP_PUBLIC_POSTHOG_HOST || "",
  REVERSE_PROXY_TARGET: process.env.REACT_APP_REVERSE_PROXY_TARGET || "",
  API_KEY: process.env.REACT_APP_API_KEY,

  ZENDESK_JWT_URL: "https://databis.zendesk.com/access/jwt",
  LABELS_HELP_ARTICLE_URL:
    "https://support.brands.databis.io/hc/en-us/articles/46417486271379",
  STRAIN_UPLOAD_TEMPLATE_URL:
    "https://d1ctlanclnckx7.cloudfront.net/content/media/Strain-upload-template_1781534115_9939eq.xlsx",
  STRAIN_PLACEHOLDER_IMAGE_URL:
    "https://d1ctlanclnckx7.cloudfront.net/content/media/Databis_Strain-Placeholder_cropped_1790590619_spd5c7.png",
  AMOY_BLOCK_EXPLORER_URL: "https://amoy.polygonscan.com/",
  AMOY_ICON_URL: "https://app.dynamic.xyz/assets/networks/polygon.svg",
  ETH_BLOCK_EXPLORER_URL: "https://etherscan.io/",
  ETH_ICON_URL: "https://app.dynamic.xyz/assets/networks/eth.svg",
  ETH_RPC_URL: "https://eth.drpc.org",
  VERSION_NAME: process.env.REACT_APP_VERSION_NAME || "1.4.0",
};
